import s from './Modals.module.scss';
import { Preloader } from 'components/Preloader/Preloader';
import { useActivateModalMutation, useGetModalsQuery } from '../../../../redux/apis/modalApi';
import { clearHTML } from 'utils/clearHTML';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ActiveIcon } from "../../../../assets/icons/completed.svg"
import { ReactComponent as DisabledIcon } from "../../../../assets/icons/close.svg"
import { ReactComponent as ClockIcon } from "../../../../assets/icons/clock_icon.svg"
import { ReactComponent as UserIcon } from "../../../../assets/icons/users.svg"
import { ReactComponent as LinkIcon } from "../../../../assets/icons/link_icon.svg"
import { Checkbox } from '@mui/material';
import { useStatusContext } from 'components/StatusProvider';
const API_URL = process.env.REACT_APP_API_ADDRESS

export const Modals = () => {

    // ### State
    const {t, i18n} = useTranslation()
    const navigate = useNavigate()
    const { openStatus } = useStatusContext();

    const {data: modals, isLoading} = useGetModalsQuery({})
    const [Activate, {isLoading: isActivateLoading}] = useActivateModalMutation()
    
    // ### Functions

    async function handleActivate(id: number, value: boolean){
        const response = await Activate({id, value})
        if(response?.data?.message === "updated")
            openStatus('success', "Modal updated");
        else openStatus('error', "The modal is already activated.");
    }

    // ### Views
    const modalsView = modals?.map((modal: any, index: number) => {
        return(
            <div key={index} className={s.modal_wrapper} onClick={() => navigate(`/modals/update?id=${modal.id}`)}>
                <div className={s.left}>
                    <img src={`${API_URL}${modal.image?.[modal.image?.default_image]}`} alt="image" />
                </div> 
                <div className={s.right}>
                    {modal. is_title ? <p className={s.title}>{clearHTML(modal.title[i18n.language])}</p> : null}
                    {modal.is_description ? <p className={s.description}>{clearHTML(modal.description[i18n.language])}</p> : null}
                    {
                        modal?.active ?
                            <div className={s.row}>
                                <ActiveIcon/>
                                <span>Active</span>
                            </div>
                            :
                            <div className={`${s.row} ${s.disable}`}>
                                <DisabledIcon/>
                                <span>Disable</span>
                            </div>
                    }
                    <div className={s.row}>
                        <ClockIcon/>
                        <span>{`Interval: ${modal.interval} hours`}</span>
                    </div>
                    {/* <div className={s.row}>
                        <UserIcon/>
                        <span>{`Show type: ${modal.show_type}`}</span>
                    </div> */}
                    <div className={s.row}>
                        <LinkIcon/>
                        <span>{`Link: ${modal.link}`}</span>
                    </div>
                </div>
                <div 
                    className={s.activate_wrapper} 
                    onClick={(e) => e.stopPropagation()}
                    style={{border: modal.active ? "1px #9CFF6D solid" : "1px #7a1818 solid"}}
                >
                    <Checkbox
                        disabled={isActivateLoading}
                        checked={modal.active}
                        onChange={(e, value) => {
                            handleActivate(modal.id, value)
                        }}  
                    />
                    <div className={`${s.title} ${!modal.active ? s.disable : ""}`}>{modal.active ? "Active" : "Disable"}</div>
                </div>
            </div>
        )
    })

    if(isLoading) return <Preloader />

    return(
        <div className={s.wrapper}>
            {modalsView}
        </div>
    )
}